import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const SdkDebuggerSessionTable = lazy(() =>
  import("@scenes/SDKDebugger/components/SdkDebuggerSessionTable/").then((module) => ({
    default: module.SdkDebuggerSessionTable,
  }))
);

export const sdkDebuggerNRO: NavigationRoutingObject = {
  Component: SdkDebuggerSessionTable,
  componentFeatureFlippers: ["sdk_debugger"],
  noKnockoutFallback: true,
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("sdk-debugger-nro-heading", "SDK Debugger"),
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission }) => {
    const hasViewPermission = featureOn("feature_flags_granular_permissions_sdk_debugger")
      ? hasPermission("appGroup", { permission: "viewSdkDebugger" })
      : hasPermission("appGroup", { permission: "developerConsole" });
    return featureOn("sdk_debugger") && hasViewPermission;
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
};
